export enum CollectedFields {
  Date = 'Date',
  User = 'UserName',
  ProjectName = 'TeamName'
}
